export enum QueuedNotificationType {
    'userJoinedGame' = 'userJoinedGame',
    'userRequestedToJoinGame' = 'userRequestedToJoinGame',
    'userInvitedToJoinGame' = 'userInvitedToJoinGame',
    'userApprovedRequestToJoinGame' = 'userApprovedRequestToJoinGame',
    'userCreatedGame' = 'userCreatedGame',
    'userCanceledGame' = 'userCanceledGame',
    'userLeftGame' = 'userLeftGame',
    'userApprovedInvitationToJoinGame' = 'userApprovedInvitationToJoinGame',
    'timeSlotAvailable' = 'timeSlotAvailable',
    'eventCreated' = 'eventCreated',
    'userJoinedEvent' = 'userJoinedEvent',
    'cohortNotification' = 'cohortNotification',
};

export type QueuedNotification<TType extends QueuedNotificationType> = {
    type: TType;
};
export type NotificationDataPayload = {
    url?: string;
    type: QueuedNotificationType;
}
